
import api from './api';

const PostsService = {
  // Get all posts with optional filtering
  getPosts: (params = {}) => {
    return api.get('/posts', { params });
  },
    // Vote on a poll
  voteOnPoll: (postId, optionId, action = "vote") => {
    return api.post(`/posts/${postId}/poll/vote`, {
      option_id: optionId,
      action
    });
  },

  // Get a single post by ID
  getPostById: (idOrVanityUrl) => {
    return api.get(`/posts/${idOrVanityUrl}`);
  },

  // Create a new post
  createPost: (postData) => {
    return api.post('/posts/create', postData);
  },

  // Update an existing post
  updatePost: (postId, postData) => {
    return api.post(`/posts/${postId}/update`, postData);
  },

  // Delete a post
  deletePost: (postId) => {
    return api.post(`/posts/${postId}/delete`);
  },

  // Like or unlike a post
  toggleLike: (postId, is_liked) => {
    return api.post(`/posts/${postId}/like`, { is_liked });
  },

  // Get post likes
  getPostLikes: (postId, page) => {
    return api.get(`/posts/${postId}/likes`, { params: { page } });
  },

  // Get posts by category
  getPostsByCategory: (categoryId, params = {}) => {
    return api.get(`/posts/category/${categoryId}`, { params });
  },

  // Report a post
  reportPost: (postId, reason) => {
    return api.post(`/report`, { reason, post_id: postId });
  },

};

export default PostsService;
